import { Modal } from '@trackman/web-shared-components';
import './VideoModal.scss';
import { VideoPlayer } from 'components/VideoPlayer/VideoPlayer';

type Props = {
  isModalOn: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  modalData: { url: string; title: string; allowedFeatures: string };
};

export const VideoModal = ({ isModalOn, setIsModalOn, modalData }: Props) => {
  return (
    <Modal onClose={() => setIsModalOn(false)} open={isModalOn} className='video-modal'>
      <div className='modal-body' style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
        <VideoPlayer
          url={modalData.url}
          title={modalData.title}
          allowedFeatures={modalData.allowedFeatures}
          customStyles={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        />
      </div>
    </Modal>
  );
};
